// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__4w9D4","rootSuccess":"CompleteLink_rootSuccess___xZib","rootFailure":"CompleteLink_rootFailure__3oOqz","isDisabled":"CompleteLink_isDisabled__3rF82"};